import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "p-5"
};
const _hoisted_3 = { class: "subtitle" };
const _hoisted_4 = { class: "columns" };
const _hoisted_5 = { class: "column" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Partner", -1);
const _hoisted_7 = { class: "column" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "User.Role", -1);
const _hoisted_9 = { class: "columns" };
const _hoisted_10 = { class: "columns" };
const _hoisted_11 = {
    key: 0,
    class: "column"
};
const _hoisted_12 = { class: "message is-small is-danger" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "message-header" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Network Admin Controls")
], -1);
const _hoisted_14 = { class: "message-body" };
const _hoisted_15 = {
    key: 0,
    class: "column"
};
const _hoisted_16 = { class: "message is-small is-link" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "message-header" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Partner Controls")
], -1);
const _hoisted_18 = { class: "message-body" };
const _hoisted_19 = { key: 0 };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Profile", -1);
const _hoisted_21 = { class: "columns" };
const _hoisted_22 = { class: "columns is-mobile" };
const _hoisted_23 = { class: "columns" };
const _hoisted_24 = { class: "columns" };
const _hoisted_25 = { class: "columns" };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Attachments", -1);
const _hoisted_28 = { class: "columns is-multiline" };
const _hoisted_29 = { class: "label" };
const _hoisted_30 = { key: 2 };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Enable / Disable Caseworker", -1);
const _hoisted_32 = { class: "columns is-mobile" };
const _hoisted_33 = { class: "column" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("div", { class: "mt-2" }, "Un-check this box to disable this caseworker", -1);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("ul", { class: "ml-1" }, [
    /*#__PURE__*/ _createElementVNode("li", null, "• Citizens will not be able to register under this caseworker"),
    /*#__PURE__*/ _createElementVNode("li", null, "• Billing will be turned off for this caseworker")
], -1);
const _hoisted_36 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Ambassador Program", -1);
const _hoisted_38 = { class: "columns is-mobile" };
const _hoisted_39 = { class: "column" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Preferences", -1);
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-3" }, "Which email notifications should this caseworker receive?", -1);
const _hoisted_42 = { class: "columns is-mobile" };
const _hoisted_43 = { class: "column" };
const _hoisted_44 = { key: 3 };
const _hoisted_45 = { key: 4 };
const _hoisted_46 = { class: "mb-2" };
const _hoisted_47 = { class: "mb-2" };
import DocumentUploadWidget from "@/components/DocumentUploadWidget.vue";
import TypeAhead from "@/components/TypeAhead.vue";
import { useAsync } from "@/composables/useAsync";
import { Validations, useValidation } from "@/composables/useValidation";
import { doApiAction } from "@/core/api";
import { ProfileTypes, User, Core, Feature } from '@minicity/core';
import { canSeeFeature, isFeatureEnabled, isNetworkAdmin, proxyLoginAsPartnerUser, sessionState } from "@/core/session";
import { notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";
import { apiPartnerOnboarding } from "@/features/partnerOnboarding/api";
import UserNotificationPreferencesEditor from "@/features/userSettings/UserNotificationPreferencesEditor.vue";
import { apiPartnerUsers } from "./api";
import { watchQueryParam } from "@/composables/watchQueryParam";
var Tab;
(function (Tab) {
    Tab["DETAILS"] = "User Details";
    Tab["ATTACHMENTS"] = "Attachments";
    Tab["PREFERENCES"] = "Preferences & Settings";
    Tab["COMMENTS"] = "Comments";
    Tab["TASKS"] = "Tasks";
})(Tab || (Tab = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerUserDetailPanel',
    props: {
        partnerUserId: {}
    },
    setup(__props) {
        const props = __props;
        const partnerUser = useAsync();
        const allCaseworkers = useAsync();
        onMounted(() => {
            if (!sessionState.session)
                return;
            partnerUser.fetch(apiPartnerUsers.get(props.partnerUserId), "Failed to load partner user")
                .then((pu) => {
                if (canSeeFeature('sites')) {
                    allCaseworkers.fetch(apiPartnerUsers.getForPartner(pu.partner.id), "Failed to load caseworkers");
                }
            });
            if (new URL(window.location.toString()).searchParams.has('taskId')) {
                activeTab.value = Tab.TASKS;
            }
        });
        // Tabs
        const activeTab = ref(Tab.DETAILS);
        watch(activeTab, watchQueryParam(activeTab, 'tab'));
        // Form validation
        const { areAllFieldsValid, validator } = useValidation();
        // UI state
        const inProgressAction = ref(null);
        // Actions
        const approvePartnerUser = () => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `approve`;
            apiPartnerOnboarding.approvePartnerUser(partnerUser.data.id)
                .then(() => {
                partnerUser.data.isPendingApproval = false;
                partnerUser.data.isPendingPortalInvite = false;
                partnerUser.data.shown = true;
                notifySuccess("User approved");
            })
                .catch(err => notifyNetworkError("Failed to approve user", err))
                .finally(() => inProgressAction.value = null);
        };
        const invitePartnerUserToPortal = () => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `inviteToPortal`;
            apiPartnerUsers.inviteToPartnerPortal(partnerUser.data.id)
                .then(() => {
                partnerUser.data.isPendingPortalInvite = false;
                notifySuccess("User invited to Partner Portal");
            })
                .catch(err => notifyNetworkError("Failed to invite user to Partner Portal", err))
                .finally(() => inProgressAction.value = null);
        };
        const saveProfile = () => {
            if (inProgressAction.value)
                return;
            if (!areAllFieldsValid.value) {
                notifyError("Please check for invalid form inputs");
                return;
            }
            else {
                doSaveProfile();
            }
        };
        const doSaveProfile = () => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `saveProfile`;
            apiPartnerUsers.setProfile(partnerUser.data.id, partnerUser.data.profile)
                .then(() => notifySuccess("Profile saved"))
                .catch(err => notifyNetworkError("Failed to update profile", err))
                .finally(() => inProgressAction.value = null);
        };
        const docTypes = {
            'STATE_ID': 'State ID',
            'WORK_BADGE': 'Work Badge',
            'WAIVER_FORM': 'Waiver Form',
            'SIGNATURE': 'Signature'
        };
        const deleteDocument = (doc, type) => {
            doApiAction(inProgressAction, 'deleteDocument', "Attachment deleted", "Failed to delete attachment", () => apiPartnerUsers.deleteAttachment(partnerUser.data.id, doc.id).then(() => { delete partnerUser.data.attachments[type]; }));
        };
        const uploadDocument = (uploadInfo, type) => {
            doApiAction(inProgressAction, 'deleteDocument', "Attachment uploaded", "Failed to upload attachment", () => apiPartnerUsers.uploadAttachment(partnerUser.data.id, type, uploadInfo.file)
                .then(doc => { partnerUser.data.attachments[type] = doc; })
                .finally(() => uploadInfo.onDone()));
        };
        const downloadDocument = (doc) => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `downloadDocument`;
            apiPartnerUsers.getAttachmentViewLink(partnerUser.data.id, doc.id)
                .then((attachmentViewLink) => window.open(attachmentViewLink))
                .catch(err => notifyNetworkError("Failed to download attachment", err))
                .finally(() => inProgressAction.value = null);
        };
        const saveDisplayName = () => {
            doApiAction(inProgressAction, 'saveDisplayName', "Display name saved", "Failed to update display name", () => apiPartnerUsers.setDisplayName(partnerUser.data.id, partnerUser.data.displayName));
        };
        const saveEmail = () => {
            doApiAction(inProgressAction, 'saveEmail', "Email saved", "Failed to update email", () => apiPartnerUsers.setEmail(partnerUser.data.id, partnerUser.data.email));
        };
        const saveShownStatus = () => {
            doApiAction(inProgressAction, 'saveShownStatus', "Shown status saved", "Failed to update shown status", () => apiPartnerUsers.setShownStatus(partnerUser.data.id, partnerUser.data.shown));
        };
        const savePreferences = () => {
            doApiAction(inProgressAction, 'savePreferences', "User preferences saved", "Failed to update user preferences", () => apiPartnerUsers.setPreferences(partnerUser.data.id, partnerUser.data.preferences));
        };
        const saveAssignedAmbassadors = () => {
            doApiAction(inProgressAction, 'saveAssignedAmbassadors', "Ambassadors saved", "Failed to update amabassadors", () => apiPartnerUsers.setAssignedAmbassadors(partnerUser.data.id, partnerUser.data.assignedAmbassadors));
        };
        const reassignAllCitizensModalShown = ref(false);
        const reassignAllCitizensCaseworker = ref(null);
        const allCaseworkersExceptSelf = computed(() => partnerUser.status != 'ready' || allCaseworkers.status != 'ready' ? [] : allCaseworkers.data.filter((pu) => pu.id != partnerUser.data.id));
        const reassignAllCitizens = () => {
            reassignAllCitizensCaseworker.value = null;
            reassignAllCitizensModalShown.value = true;
        };
        const doReassignAllCitizens = () => {
            if (reassignAllCitizensCaseworker.value == null) {
                notifyError("Please select a caseworker above");
                return;
            }
            doApiAction(inProgressAction, "reassignAllCitizens", "Citizens reassigned", "Failed to reassign citizens", () => apiPartnerUsers.reassignAllCitizens(partnerUser.data.id, reassignAllCitizensCaseworker.value.id)
                .then(() => reassignAllCitizensCaseworker.value = null));
        };
        const changeUserRole = (role) => {
            doApiAction(inProgressAction, "changeUserRole", "User role changed", "Failed to change user role", () => apiPartnerUsers.setUserRole(partnerUser.data.id, role).then(() => partnerUser.data.role = role));
        };
        const instance = getCurrentInstance();
        const proxyLogin = () => {
            doApiAction(inProgressAction, "proxyLogin", "Logged-in as user", "Failed to login as user", () => proxyLoginAsPartnerUser(partnerUser.data.id).then((res) => instance.proxy.$router.push("/")));
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_HeaderSectionLayout = _resolveComponent("HeaderSectionLayout");
            const _component_TabsHeader = _resolveComponent("TabsHeader");
            const _component_FormSelectField = _resolveComponent("FormSelectField");
            const _component_FormCheckboxField = _resolveComponent("FormCheckboxField");
            const _component_FormStringListField = _resolveComponent("FormStringListField");
            const _component_CommentSection = _resolveComponent("CommentSection");
            const _component_TaskSection = _resolveComponent("TaskSection");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_unref(isFeatureEnabled)('SITES'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_unref(partnerUser).status == 'loading')
                        ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                        : (_unref(partnerUser).status == 'ready')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_HeaderSectionLayout, null, {
                                    title: _withCtx(() => [
                                        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(partnerUser).data.displayName), 1)
                                    ]),
                                    fields: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _hoisted_6,
                                                _createVNode(_component_PartnerBadge, {
                                                    partner: _unref(partnerUser).data.partner
                                                }, null, 8, ["partner"])
                                            ]),
                                            _createElementVNode("div", _hoisted_7, [
                                                _hoisted_8,
                                                _createElementVNode("span", null, _toDisplayString(_unref(User).Role_Label[_unref(partnerUser).data.role]), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createVNode(_component_FormTextField, {
                                                label: "Display Name",
                                                modelValue: _unref(partnerUser).data.displayName,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(partnerUser).data.displayName) = $event))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_SaveButton, {
                                                        action: "saveDisplayName",
                                                        icon: "fa-save",
                                                        inProgressAction: inProgressAction.value,
                                                        onClick: _cache[0] || (_cache[0] = ($event) => (saveDisplayName())),
                                                        style: { "margin-top": "5px" }
                                                    }, null, 8, ["inProgressAction"])
                                                ]),
                                                _: 1
                                            }, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(_component_FormTextField, {
                                                label: "Email",
                                                modelValue: _unref(partnerUser).data.email,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(partnerUser).data.email) = $event))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_SaveButton, {
                                                        action: "saveEmail",
                                                        icon: "fa-save",
                                                        inProgressAction: inProgressAction.value,
                                                        onClick: _cache[2] || (_cache[2] = ($event) => (saveEmail())),
                                                        style: { "margin-top": "5px" }
                                                    }, null, 8, ["inProgressAction"])
                                                ]),
                                                _: 1
                                            }, 8, ["modelValue"])
                                        ])
                                    ]),
                                    networkAdminControls: _withCtx(() => [
                                        (_unref(isNetworkAdmin)())
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createElementVNode("article", _hoisted_12, [
                                                    _hoisted_13,
                                                    _createElementVNode("div", _hoisted_14, [
                                                        (_unref(partnerUser).data.isPendingApproval)
                                                            ? (_openBlock(), _createBlock(_component_SaveButton, {
                                                                key: 0,
                                                                label: "Approve",
                                                                icon: "fa-check",
                                                                action: "approve",
                                                                inProgressAction: inProgressAction.value,
                                                                onClick: _cache[4] || (_cache[4] = ($event) => (approvePartnerUser()))
                                                            }, null, 8, ["inProgressAction"]))
                                                            : (_openBlock(), _createBlock(_component_SaveButton, {
                                                                key: 1,
                                                                label: _unref(partnerUser).data.isPendingPortalInvite ? 'Invite To Portal' : 'Re-invite To Portal',
                                                                icon: "fa-bullhorn",
                                                                action: "inviteToPortal",
                                                                inProgressAction: inProgressAction.value,
                                                                onClick: _cache[5] || (_cache[5] = ($event) => (invitePartnerUserToPortal()))
                                                            }, null, 8, ["label", "inProgressAction"])),
                                                        (_unref(partnerUser).data.role == _unref(User).Role.PARTNER_ADMIN)
                                                            ? (_openBlock(), _createBlock(_component_SaveButton, {
                                                                key: 2,
                                                                label: "Downgrade To Regular User",
                                                                icon: "fa-angle-double-down",
                                                                action: "changeUserRole",
                                                                inProgressAction: inProgressAction.value,
                                                                onClick: _cache[6] || (_cache[6] = ($event) => (changeUserRole(_unref(User).Role.PARTNER_USER)))
                                                            }, null, 8, ["inProgressAction"]))
                                                            : _createCommentVNode("", true),
                                                        (_unref(partnerUser).data.role == _unref(User).Role.PARTNER_USER)
                                                            ? (_openBlock(), _createBlock(_component_SaveButton, {
                                                                key: 3,
                                                                label: "Upgrade To Partner Admin",
                                                                icon: "fa-angle-double-up",
                                                                action: "changeUserRole",
                                                                inProgressAction: inProgressAction.value,
                                                                onClick: _cache[7] || (_cache[7] = ($event) => (changeUserRole(_unref(User).Role.PARTNER_ADMIN)))
                                                            }, null, 8, ["inProgressAction"]))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(_component_SaveButton, {
                                                            label: "Login As This User",
                                                            icon: "fa-sign-in-alt",
                                                            action: "proxyLogin",
                                                            inProgressAction: inProgressAction.value,
                                                            onClick: _cache[8] || (_cache[8] = ($event) => (proxyLogin()))
                                                        }, null, 8, ["inProgressAction"])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    partnerControls: _withCtx(() => [
                                        (_unref(canSeeFeature)('sites'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                _createElementVNode("article", _hoisted_16, [
                                                    _hoisted_17,
                                                    _createElementVNode("div", _hoisted_18, [
                                                        (_unref(allCaseworkers).status == 'ready')
                                                            ? (_openBlock(), _createBlock(_component_SaveButton, {
                                                                key: 0,
                                                                label: "Reassign All Citizens",
                                                                icon: "fa-people-arrows",
                                                                action: "reassignAllCitizens",
                                                                inProgressAction: inProgressAction.value,
                                                                onClick: _cache[9] || (_cache[9] = ($event) => (reassignAllCitizens()))
                                                            }, null, 8, ["inProgressAction"]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_TabsHeader, {
                                    modelValue: activeTab.value,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((activeTab).value = $event)),
                                    tabs: Tab,
                                    entityType: _unref(Core).EntityType['Partner User'],
                                    entityId: _unref(partnerUser).data.id
                                }, null, 8, ["modelValue", "entityType", "entityId"]),
                                (activeTab.value == Tab.DETAILS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _hoisted_20,
                                        _createElementVNode("div", _hoisted_21, [
                                            _createVNode(_component_FormTextField, {
                                                label: "First Name *",
                                                modelValue: _unref(partnerUser).data.profile.firstName,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(partnerUser).data.profile.firstName) = $event)),
                                                validator: _unref(validator)(_unref(Validations).notEmpty)
                                            }, null, 8, ["modelValue", "validator"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "Middle Name",
                                                modelValue: _unref(partnerUser).data.profile.middleName,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(partnerUser).data.profile.middleName) = $event))
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "Last Name *",
                                                modelValue: _unref(partnerUser).data.profile.lastName,
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(partnerUser).data.profile.lastName) = $event)),
                                                validator: _unref(validator)(_unref(Validations).notEmpty)
                                            }, null, 8, ["modelValue", "validator"])
                                        ]),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createVNode(_component_FormTextField, {
                                                label: "Phone",
                                                modelValue: _unref(partnerUser).data.profile.phone,
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(partnerUser).data.profile.phone) = $event))
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "Job Title",
                                                modelValue: _unref(partnerUser).data.profile.jobTitle,
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(partnerUser).data.profile.jobTitle) = $event))
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                            _createVNode(_component_FormTextField, {
                                                label: "Building Number",
                                                modelValue: _unref(partnerUser).data.profile.address.number,
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(partnerUser).data.profile.address.number) = $event))
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "Street",
                                                modelValue: _unref(partnerUser).data.profile.address.street,
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(partnerUser).data.profile.address.street) = $event))
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_24, [
                                            _createVNode(_component_FormTextField, {
                                                label: "City",
                                                modelValue: _unref(partnerUser).data.profile.address.city,
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(partnerUser).data.profile.address.city) = $event))
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_FormSelectField, {
                                                label: "State",
                                                modelValue: _unref(partnerUser).data.profile.address.state,
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(partnerUser).data.profile.address.state) = $event)),
                                                options: _unref(ProfileTypes).StateNotUnknown
                                            }, null, 8, ["modelValue", "options"])
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                            _createVNode(_component_FormTextField, {
                                                label: "Postal Code",
                                                modelValue: _unref(partnerUser).data.profile.address.postalCode,
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(partnerUser).data.profile.address.postalCode) = $event)),
                                                numeric: "",
                                                length: 9
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "Country",
                                                modelValue: _unref(partnerUser).data.profile.address.country,
                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_unref(partnerUser).data.profile.address.country) = $event))
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _createVNode(_component_SaveButton, {
                                            label: "Save Profile",
                                            icon: "fa-save",
                                            action: "saveProfile",
                                            inProgressAction: inProgressAction.value,
                                            onClick: _cache[22] || (_cache[22] = ($event) => (saveProfile()))
                                        }, null, 8, ["inProgressAction"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.ATTACHMENTS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _hoisted_27,
                                        _createElementVNode("div", _hoisted_28, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(docTypes, (docTypeLabel, docTypeId) => {
                                                return _createElementVNode("div", {
                                                    class: "column",
                                                    key: docTypeId
                                                }, [
                                                    _createElementVNode("label", _hoisted_29, _toDisplayString(docTypeLabel), 1),
                                                    _createVNode(DocumentUploadWidget, {
                                                        singleDocument: _unref(partnerUser).data.attachments[docTypeId],
                                                        onDelete: ($event) => (deleteDocument($event, docTypeId)),
                                                        onUpload: ($event) => (uploadDocument($event, docTypeId)),
                                                        onView: _cache[23] || (_cache[23] = ($event) => (downloadDocument($event)))
                                                    }, null, 8, ["singleDocument", "onDelete", "onUpload"])
                                                ]);
                                            }), 64))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.PREFERENCES)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _hoisted_31,
                                        _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, [
                                                _createVNode(_component_FormCheckboxField, {
                                                    boxLabel: "Enable Caseworker",
                                                    modelValue: _unref(partnerUser).data.shown,
                                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_unref(partnerUser).data.shown) = $event))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_34,
                                                        _hoisted_35,
                                                        _createVNode(_component_SaveButton, {
                                                            action: "saveShownStatus",
                                                            icon: "fa-save",
                                                            inProgressAction: inProgressAction.value,
                                                            onClick: _cache[24] || (_cache[24] = ($event) => (saveShownStatus())),
                                                            style: { "margin-top": "5px" }
                                                        }, null, 8, ["inProgressAction"])
                                                    ]),
                                                    _: 1
                                                }, 8, ["modelValue"])
                                            ])
                                        ]),
                                        (_unref(isFeatureEnabled)(_unref(Feature).Type.AMBASSADOR_PROGRAM))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                _hoisted_37,
                                                _createElementVNode("div", _hoisted_38, [
                                                    _createElementVNode("div", _hoisted_39, [
                                                        _createVNode(_component_FormStringListField, {
                                                            label: "Ambassadors",
                                                            icon: "fa-user",
                                                            modelValue: _unref(partnerUser).data.assignedAmbassadors,
                                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_unref(partnerUser).data.assignedAmbassadors) = $event))
                                                        }, null, 8, ["modelValue"]),
                                                        _createVNode(_component_SaveButton, {
                                                            action: "saveAssignedAmbassadors",
                                                            icon: "fa-save",
                                                            inProgressAction: inProgressAction.value,
                                                            onClick: _cache[27] || (_cache[27] = ($event) => (saveAssignedAmbassadors()))
                                                        }, null, 8, ["inProgressAction"])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        _hoisted_40,
                                        _hoisted_41,
                                        _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                                _createVNode(UserNotificationPreferencesEditor, {
                                                    modelValue: _unref(partnerUser).data.preferences.notifications,
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_unref(partnerUser).data.preferences.notifications) = $event))
                                                }, null, 8, ["modelValue"]),
                                                _createVNode(_component_SaveButton, {
                                                    action: "savePreferences",
                                                    icon: "fa-save",
                                                    inProgressAction: inProgressAction.value,
                                                    onClick: _cache[29] || (_cache[29] = ($event) => (savePreferences())),
                                                    style: { "margin-top": "5px" }
                                                }, null, 8, ["inProgressAction"])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.COMMENTS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _createVNode(_component_CommentSection, {
                                            getComments: () => _unref(apiPartnerUsers).getComments(_unref(partnerUser).data.id),
                                            addComment: (message, attachments, notifyCaseworker) => _unref(apiPartnerUsers).addComment(_unref(partnerUser).data.id, message, attachments, notifyCaseworker),
                                            getAttachmentViewLink: (commentId, attachmentId) => _unref(apiPartnerUsers).getCommentAttachmentViewLink(_unref(partnerUser).data.id, commentId, attachmentId)
                                        }, null, 8, ["getComments", "addComment", "getAttachmentViewLink"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.TASKS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                        _createVNode(_component_TaskSection, {
                                            allowShowAll: "",
                                            getTasks: () => _unref(apiPartnerUsers).getTasks(_unref(partnerUser).data.id),
                                            addTask: (audience, message) => _unref(apiPartnerUsers).addTask(_unref(partnerUser).data.id, audience, message)
                                        }, null, 8, ["getTasks", "addTask"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                    _createVNode(_component_ModalDialog, {
                        active: reassignAllCitizensModalShown.value,
                        title: "Reassign all citizens",
                        severity: "info",
                        allowClose: true,
                        onClose: _cache[31] || (_cache[31] = ($event) => (reassignAllCitizensModalShown.value = false)),
                        firstButtonText: "Cancel",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[32] || (_cache[32] = ($event) => (reassignAllCitizensModalShown.value = false))
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createElementVNode("p", _hoisted_46, [
                                    _createElementVNode("strong", null, "Select a caseworker below to reassign ALL citizens under the care of " + _toDisplayString((_a = _unref(partnerUser).data) === null || _a === void 0 ? void 0 : _a.displayName) + " to them.", 1)
                                ]),
                                (_unref(allCaseworkers).data)
                                    ? (_openBlock(), _createBlock(TypeAhead, {
                                        key: 0,
                                        "prop-data": allCaseworkersExceptSelf.value,
                                        onItemSelected: _cache[30] || (_cache[30] = ($event) => { reassignAllCitizensCaseworker.value = $event; reassignAllCitizensModalShown.value = false; }),
                                        placeholder: "Type to reassign all citizens...",
                                        icon: "fas fa-user",
                                        labelField: "displayName"
                                    }, null, 8, ["prop-data"]))
                                    : _createCommentVNode("", true)
                            ];
                        }),
                        _: 1
                    }, 8, ["active"]),
                    _createVNode(_component_ModalDialog, {
                        active: reassignAllCitizensCaseworker.value != null,
                        title: "Reassign all citizens",
                        severity: "danger",
                        allowClose: true,
                        onClose: _cache[33] || (_cache[33] = ($event) => (reassignAllCitizensCaseworker.value = null)),
                        firstButtonText: "Cancel",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[34] || (_cache[34] = ($event) => (reassignAllCitizensCaseworker.value = null)),
                        secondButtonText: "Reassign",
                        secondButtonSeverity: "danger",
                        onSecondbuttonselected: _cache[35] || (_cache[35] = ($event) => (doReassignAllCitizens()))
                    }, {
                        default: _withCtx(() => {
                            var _a, _b;
                            return [
                                _createElementVNode("p", _hoisted_47, [
                                    _createElementVNode("strong", null, "Are you sure you want to reassign ALL citizens under the care of " + _toDisplayString((_a = _unref(partnerUser).data) === null || _a === void 0 ? void 0 : _a.displayName) + " to " + _toDisplayString((_b = reassignAllCitizensCaseworker.value) === null || _b === void 0 ? void 0 : _b.displayName) + "?", 1)
                                ])
                            ];
                        }),
                        _: 1
                    }, 8, ["active"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
